/**
 * 收藏单商品
 */
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { ProductImage, Radio } from '@cps'
import { ProductScales } from '..'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { favoMobx } from 'mobx/mall'
import { CollectScaleModal } from '../../modal'
import { MallController } from '@ctrls/mallController'
import './index.scss'

interface IProps {
  product: IMallFavoProduct;
  isGiven?: boolean; // 是否赠送
  index?: number;
  onSelect?: () => void;
  onChangePackCnt?: (cnt: number) => void;
  disabled?: boolean;
}

const ProductItem: React.FC<IProps> = ({ product }) => {
  const [allPrice, setAllPrice] = useState<number>(0)
  useEffect(() => {
    let _allPrice: number = 0;
    (product.selectScales || []).forEach((item) => {
      _allPrice += item.price * item.selectCnt
    })
    setAllPrice(_allPrice)
  }, [product.selectScales])
  const handleSeledctProduct = () => {
    if (product.selectScales && product.selectScales.length > 0) {
      setRadioSelect()
    } else {
      handleTackIt('', 0, true)
    }
  }
  const setRadioSelect = () => {
    favoMobx.setSelectProduct(product.no)
  }
  const handleProductDetail = () => {
    MallController.goToProduct(favoMobx.viewProductListMap[product.no] as any)
  }
  const handleDelete = (scaleNo: string) => {
    let selectScales = [...(product.selectScales || [])]
    let index = selectScales.findIndex((item) => item.no === scaleNo)
    selectScales.splice(index, 1)
    favoMobx.setSelectScale(product.no, selectScales)
  }
  /** 指定scaleNo isSelect 是否是radio */
  const handleTackIt = (scaleNo: string = '', index: number, isRadio: boolean = false) => {
    modalLayer(CollectScaleModal, { product, disableScaleNo: scaleNo }, 'CollectScaleModal').then((scale: any) => {
      let selectScales = [...(product.selectScales || [])]
      // 是否有相似规格的选项
      let preIndex = selectScales.findIndex((item) => item.no === scale.no)
      if (preIndex === -1) {
        if (selectScales[index]) {
          selectScales[index] = scale
        } else {
          selectScales.push(scale)
        }
      } else {
        selectScales[index] = scale
      }
      favoMobx.setSelectScale(product.no, selectScales)
      if (isRadio) setRadioSelect()
    }).catch(() => {
    })
  }
  return (
    <div
      className='mall-favo-product-item'
      key={product.no}
    >
      <Radio
        value={favoMobx.selectProductNoMap[product.no]}
        onChange={handleSeledctProduct}
      />
      <div className='product-info'>
        <div className='item-detail'>
          <ProductImage type='mall' color={!product.pic ? product.no : ''} width={64} imgSrc={product.pic} onClick={handleProductDetail} />
          <div className='item-right-wrapper'>
            <div className='product-name' onClick={handleProductDetail}>
              <strong>{product.name}</strong>
              <div className='product-price'>
                <div className='price' dangerouslySetInnerHTML={{ __html: format.toPriceLittleCurrency(allPrice || product.price) }}></div>
                {product.selectScales?.length > 1 && <div className='txt'>{i18n.t('cart.subtotal')}</div>}
              </div>
            </div>
            {!product.isSingleScale && <ProductScales product={product} onDelete={handleDelete} onChange={handleTackIt} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default observer(ProductItem)
